import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var CombineOrdersIA = function CombineOrdersIA(_ref) {
  var shipInternational = _ref.shipInternational;
  if (shipInternational) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9Brnnd",
      defaultMessage: [{
        "type": 0,
        "value": "Als je bestellingen die internationaal worden verzonden wilt combineren, moet je één van de bestellingen bewerken en alle artikelen van de andere bestelling toevoegen. Als je dat hebt gedaan, kun je doorgaan en de tweede bestelling annuleren en deze bestellingen als één bestelling verzenden. Houd er rekening mee dat je bestellingen die klaar zijn om te verzenden niet kunt combineren met voorbestellingen."
      }]
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Nmy24O",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt momenteel meerdere bestellingen niet combineren. Neem hieronder contact met ons op voor hulp. We kunnen dan dezelfde trackinggegevens aan meerdere bestellingen toevoegen. Dit zorgt ervoor dat je klant toegang heeft tot trackinggegevens en dat zendingen nauwkeurig worden bijgewerkt."
      }]
    })));
  }
};